module.exports = __webpack_public_path__ + "registration-53018bea/background-96bf11140742e9ad659d134d2b791492.png";